import { ShipmentStatus as S } from "../types";
import { poDate, poErr, poFmtDate, poFmtQty, poLayerBlocked, poNum } from "./purchasing";

/** Sevkiyat ekranının ortak yardımcıları (liste, çekmece, sevkiyat modalı, işlem/yazdırma pencereleri, OrderPicker). */
export const SH_STATUS_LABEL: Record<S, string> = {
  [S.Draft]: "Taslak",
  [S.Shipped]: "Sevk edildi",
  [S.Delivered]: "Teslim edildi",
  [S.Cancelled]: "İptal",
};
/** Mevcut .po-st tonlarına eşleme: gri / bilgi / yeşil / kırmızı. `s${status}` KULLANMA (3 = Delivered, po-st s3 değil s4). */
export const SH_STATUS_CLASS: Record<S, "s1" | "s2" | "s4" | "s5"> = {
  [S.Draft]: "s1",
  [S.Shipped]: "s2",
  [S.Delivered]: "s4",
  [S.Cancelled]: "s5",
};

// Eski dışa aktarımlar (OrderPicker satırları bunları kullanır)
export const fmtDate = (iso?: string | null) => (iso ? new Date(iso).toLocaleDateString("tr-TR") : "—");
export const fmtDateTime = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
export const fmtQty = (n: number) => n.toLocaleString("tr-TR", { maximumFractionDigits: 3 });

export const shFmtDate = poFmtDate;      // yalnız tarih ("12 Eyl 2026"): shipmentDate, waybillDate, orderDate, deadline, cancelledAt
export const shFmtDateTime = fmtDateTime; // gerçek anlar: shippedAt, deliveredAt, createdAt, updatedAt
export const shFmtQty = poFmtQty;
export const shErr = poErr;
export const shNum = poNum;
export const shLayerBlocked = poLayerBlocked;
export const shIsOpen = (s: S) => s === S.Draft || s === S.Shipped;

export const EPS = 0.0005;
/** Sunucu 3 basamağa yuvarlar; float gürültüsü girdiye sızmasın. Ondalık virgülle yazılır: "1.255" binlik sanılıp 1255 okunmasın. */
export const qtyText = (n: number) => String(Math.round(n * 1000) / 1000).replace(".", ",");

const QTY_PLAIN = /^(?:\d+(?:[.,]\d{1,3})?|[.,]\d{1,3})$/;   // 1250 · 1250,5 · 1250.5 · 0.125 · ,5
const QTY_TR = /^[1-9]\d{0,2}(?:\.\d{3})+(?:,\d{1,3})?$/;    // 1.250 · 1.250,5 (tr-TR binlik ayraçlı; "0.125" buraya düşmez)
export type QtyParse = { ok: true; value: number } | { ok: false; code: "empty" | "bad" | "zero" };
/** Miktar girdisi: sessizce kırpmaz, geçersizi reddeder. */
export const parseQty = (s: string): QtyParse => {
  const t = (s || "").trim();
  if (!t) return { ok: false, code: "empty" };
  let n: number;
  if (QTY_TR.test(t)) n = parseFloat(t.replace(/\./g, "").replace(",", "."));
  else if (QTY_PLAIN.test(t)) n = parseFloat(t.replace(",", "."));
  else return { ok: false, code: "bad" };
  if (!isFinite(n)) return { ok: false, code: "bad" };
  return n > EPS ? { ok: true, value: n } : { ok: false, code: "zero" };
};

/** NotificationScanner.UndeliveredDays = 3 ile aynı tutulur (ilk uyarı 3. gün, sonra 7). */
export const SH_UNDELIVERED_DAYS = 3;
export interface ShAge { days: number | null; state: "" | "soon" | "late"; stuck: boolean; text: string }
/** Yalnız Shipped için anlamlı. days = bugün − shippedAt (yerel gün). */
export const shAge = (shippedAt: string | null | undefined, status: S): ShAge => {
  if (status !== S.Shipped || !shippedAt) return { days: null, state: "", stuck: false, text: "" };
  const t = new Date(); t.setHours(0, 0, 0, 0);
  const days = Math.max(0, Math.round((t.getTime() - poDate(shippedAt).getTime()) / 86400000));
  return {
    days,
    stuck: days >= SH_UNDELIVERED_DAYS,
    state: days >= 7 ? "late" : days >= SH_UNDELIVERED_DAYS ? "soon" : "",
    text: days === 0 ? "bugün sevk edildi" : `${days} gündür yolda`,
  };
};
